import React, { useEffect } from "react";
import Tab from '@mui/material/Tab';
import Box from '@mui/material/Box';
import { connect, useSelector } from "react-redux";
// import {Grid,Button} from '@mui/material';
import {Grid} from '@mui/material';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { useDispatch } from "react-redux";
import TabContext from '@mui/lab/TabContext';
// import { updateUserRole, loadRoleList, loadAppUserList, addNewUser, importUsers } from "../api/userapi";
import { updateUserRole, loadRoleList, loadAppUserList } from "../api/userapi";
import LoaderComponent from "../components/LoaderComponent";
import SearchBoxComponent from "../components/SearchBoxComponent";
import { getUserLoading, getUserDialogStatus, getRolesList, getAppUserList } from "../selector/selectors";
import AppUserItem from "../components/AppUserItem";
import { Link } from "react-router-dom";
// import swal from 'sweetalert';
// import AddUserForm from "../components/AddUserForm";
// import swal from "sweetalert";
// import * as XLSX from 'xlsx';
// import ImportUserModal from "../components/ImportUserModal";
// import ImportUserEditModal from "../components/ImportUserEditModal";

function ManageAppUsers({
  isLoading,
  userList,
  startLoadingUsers,
  startLoadingRole,
  roleList
}) {

    const dispatch = useDispatch();
    const userType = 2;
    const [page, setPage] = React.useState(0);
    const [value, setValue] = React.useState('1');
    const [rowsPerPage, setRowsPerPage] = React.useState(10);
    const [searchValue, setSearchValue] = React.useState('');
    const [updatedUserList, setupdatedUserList] = React.useState([]);
    const [updatedRoleList, setUpdatedRoleList] = React.useState([]);
    const list  = useSelector((state) => state.userPermissionRoleData.userPermissionsRolesInfo);

    useEffect(() => {
      // startLoadingUsers('', previousController);
      startLoadingUsers(userType,'');
      startLoadingRole();
      
    }, [startLoadingRole,startLoadingUsers]);

    useEffect(() =>{
      setupdatedUserList(userList?.data)
      let roleUpdateList = roleList?.data?.filter(val => val.role_type === '2');
      setUpdatedRoleList(roleUpdateList);
    },[userList,roleList])


    const handleChange = (event, newValue) => {
      setValue(newValue);
    };

    const handleChangePage = (event, pageVal) => {
        setPage(pageVal);
        startLoadingUsers(userType,searchValue,pageVal,rowsPerPage);
    }

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(+event.target.value);
        setPage(0);
        startLoadingUsers(userType,searchValue,0,event.target.value);
    }

    const handleSearchUser = (event) => {
        setSearchValue(event.target.value);
        startLoadingUsers(userType,event.target.value);
    };

    const handleRoleChange = (event,userId) => {
        dispatch(updateUserRole(event.target.value,userId,userType,page));
        const newUserList = updatedUserList?.records?.map(item => (item.id === userId  ? { ...item,roleId:event.target.value} : item));
        setupdatedUserList({...updatedUserList,records:newUserList});
    }
    
    return (
      <Box sx={{ flexGrow: 1 }} >
        { isLoading ?  <LoaderComponent />: <></>}
        <Grid container >
         <TabContext value={value}>
            <Grid item xs={12} md={12} lg={12} >
              <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
                <TabList onChange={handleChange} aria-label="">
                  {list?.data?.userDetails?.role_id === 1 &&
                    <Link className="tabingLinks" to="/web/roles">Roles</Link>
                  } 
                  {/* <Link className="tabingLinks" to="/web/users">Users</Link> */}
                  <Tab label="Users" value="1" />
                  {list?.data?.userDetails?.role_id === 1 &&
                    <>
                    <Link className="tabingLinks" to="/web/permissions">Access Control</Link>
                    {/* <Link className="tabingLinks" to="/web/controller-permissions">Controller Access Control</Link> */}
                    </>
                  }
                </TabList>
              </Box>
              <Box sx={{paddingTop:'16px', borderBottom: 1, borderColor: 'divider' }}>
                <TabList aria-label="">
                  {list?.data?.userDetails?.role_id === 1 &&
                    <Link className="tabingLinks" to="/web/users">Rehlink Sphere Users</Link>
                  }
                  <Tab label="Rehlink users" value="1" />
                </TabList>
              </Box>
              <TabPanel value="1" sx={{p:0,pt:2}}>
                <Grid container sx={{paddingBottom:2, display: 'flex', justifyContent: 'space-between'}}>
                  <Grid xs={5} sm={6} md={3}>
                    <SearchBoxComponent
                      handleChangeTextValue = {(e)=>handleSearchUser(e,'')}
                      label='Search Email / Name'
                    />   
                  </Grid>
                </Grid>
                <AppUserItem 
                  roleList={updatedRoleList} 
                  //handlePermissionDialogOpen={handlePermissionDialogOpen} 
                  users={updatedUserList} 
                  page={page} 
                  rowsPerPage={rowsPerPage} 
                  handleChangeRowsPerPage={handleChangeRowsPerPage} 
                  handleChangePage={handleChangePage} 
                  handleRoleChange={handleRoleChange}
                  userType={userType}
                />
              </TabPanel>
            </Grid>
          </TabContext>
        </Grid>
      </Box>
    );
}
const mapStateToProps = (state) => ({
  isLoading             :   getUserLoading(state),  
  userList              :   getAppUserList(state), 
  userDialogBoxStatus   :   getUserDialogStatus(state), 
  roleList              :   getRolesList(state), 
});

const mapDispatchToProps = (dispatch) => ({
  //addNewUser:(data)                                => dispatch(addNewUser(data)),
  startLoadingUsers:(userType,searchText, page,rowsPerPage) => dispatch(loadAppUserList(userType,searchText, page,rowsPerPage)),
  startLoadingRole:()     => dispatch(loadRoleList()),
});

export default connect(mapStateToProps, mapDispatchToProps)(ManageAppUsers);

